export default __webpack_public_path__ + "static/media/settings.9591859e.svg";